import Vue from 'vue'
import ElementUI from 'element-ui'
import 'babel-polyfill'

import 'element-ui/lib/theme-chalk/index.css'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import App from './App'
import router from './router'
import store from './store'
import _ from 'lodash'
Object.defineProperty(Vue.prototype, '_', { value: _ })

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 99,
    inline: false,
    button: true,
    navbar: false,
    title: false,
    toolbar: false,
    tooltip: false,
    movable: true,
    zoomable: true,
    rotatable: false,
    scalable: false,
    transition: true,
    fullscreen: false,
    keyboard: false
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js